import React from 'react';
import { FileEntity } from '../../../../../types/file';
import CloseIcon from '../../../../icons/Close/CloseIcon';
import Modal from '../../Modal/Modal';
import FileViewLoader from '../FileViewLoader';

interface FileViewModalProps {
  file: FileEntity;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export default function FileViewModal({ open, setOpen, file }: FileViewModalProps) {
  if (!file.fileTypeCategory.includes('image') && !file.fileTypeCategory.includes('video')) return null;

  return (
    <Modal
      onClose={() => setOpen(false)}
      open={open}
      header={<></>}
      title={''}
      className='relative flex h-fit max-h-[80vh] min-h-[200px] w-fit min-w-[200px] max-w-[80vw] items-center justify-center overflow-hidden'
      width={'fit-content'}
      customLayout
    >
      <CloseIcon
        className='absolute right-2 top-2 z-10 flex h-[44px] w-[44px] cursor-pointer items-center justify-center rounded-[8px] text-gray-500 hover:bg-gray-100 hover:text-black'
        onClick={() => setOpen(false)}
      />
      <FileViewLoader fileEntityType={file.entityType} fileId={file.id} />
    </Modal>
  );
}
